import { StyleFn } from './index'

export type StylesKeys =
  | 'playPauseButton'
  | 'progressLine'
  | 'progressLineActive'

export type StylesObj = {
  [key in StylesKeys]?: StyleFn
}

export type Styles = {
  playPauseButton: StyleFn
  progressLine: StyleFn
  progressLineActive: StyleFn
}

export const defaultStyles: Styles = {
  playPauseButton: () => ({
    ...buttonStyles,
    width: '3.9em',
    height: '3.9em',
  }),
  progressLine: () => ({
    ...progressStyles,
    stroke: 'rgb(2, 1, 28)',
  }),
  progressLineActive: () => ({
    ...progressStyles,
    stroke: 'var(--rw-accent, currentColor)',
    strokeLinecap: 'round',
    strokeDasharray: '219.9114857512855px',
    transformOrigin: 'center center',
  }),
}

export const buttonStyles = {
  border: 0,
  outline: 0,
  background: 'none',
  padding: 0,
  cursor: 'pointer',
  font: 'inherit',
  transition: 'opacity 0.3s',
  lineHeight: 0,
  opacity: 0.85,
  '&:hover:not(:disabled)': {
    opacity: 1,
  },
  '&:disabled': {
    cursor: 'default',
    opacity: 0.3,
  },
}

const progressStyles = {
  fill: 'none',
  transform: 'rotate(-90deg)',
  transformOrigin: 'center',
  transition: 'opacity 0.3s',
}
